import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=36e75e66&"
import script from "./empty.vue?vue&type=script&lang=js&"
export * from "./empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e75e66')) {
      api.createRecord('36e75e66', component.options)
    } else {
      api.reload('36e75e66', component.options)
    }
    module.hot.accept("./empty.vue?vue&type=template&id=36e75e66&", function () {
      api.rerender('36e75e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/empty.vue"
export default component.exports